package fyi.moko.hotpl.data.backup

import kotlinx.serialization.Serializable

@Serializable
data class HotplBackupFile(
    val formatVersion: Int,
    val exportedAt: Long,
    val places: List<HotplBackupPlace>,
)

@Serializable
data class HotplBackupPlace(
    val name: String,
    val note: String?,
    val locationContext: String?,
    val tags: List<String>,
    val liked: Boolean,
    val latitude: Double?,
    val longitude: Double?,
    val createdAt: Long,
    val updatedAt: Long,
    val visits: List<HotplBackupVisit>,
    val version: Long? = null,
    val revisitCadence: String? = null,
    val costFeel: String? = null,
    val phoneNumber: String? = null,
    val website: String? = null,
    /**
     * [fyi.moko.hotpl.domain.model.PlaceStatus] name. Absent in backups written before
     * 0-22 (visit inference) started saving WISHLIST — null reads back as VISITED.
     */
    val status: String? = null,
)

@Serializable
data class HotplBackupVisit(
    val visitedAt: Long,
    val note: String?,
    val emotion: String? = null,
)

data class BackupImportPreview(
    val placeCount: Int,
    val visitCount: Int,
)

data class PreparedHotplBackup(
    val file: HotplBackupFile,
    val preview: BackupImportPreview,
)

class BackupValidationException(message: String) : IllegalArgumentException(message)